import { useMemo } from 'react'

import CorporateSalesmanshipV1 from 'pared/pages/v1/CorporateSalesmanship'
import CorporateSalesmanshipV2 from 'pared/pages/v2/CorporateSalesmanship'
import { getBrand } from 'pared/utils/brand'

const useCorporateSalesmanshipConfig = (): any => {
  const brand = getBrand()

  return useMemo(() => {
    if (!brand) {
      return null
    }

    switch (brand) {
      case 'rmg':
      case 'rmg_nso':
      case 'sullivans':
      case 'sullivans_nso':
      case 'eddiemerlots':
      case 'eddiemerlots_nso':
      case 'papajohns':
      case 'papajohns_demo':
      case 'qsr_shack':
      case 'casual_fare':
        return CorporateSalesmanshipV1
      case 'irmg_bk':
      case 'irmg_pop':
      case 'supreme_pop':
      case 'ghai_pop':
      case 'viking_bk':
      case 'jsc_bk':
      case 'jsc_bk_nso':
      case 'sandbox_bk':
      case 'multi_king_bk':
      case 'supreme_bk':
      case 'timoney_bk':
      case 'mbn_bk':
      case 'demo_bk':
      case 'demo_pop':
      case 'wingstop':
      case 'jitb':
      case 'ace_pop':
      default:
        return CorporateSalesmanshipV2
    }
  }, [brand])
}
export default useCorporateSalesmanshipConfig
